<div class="arrow-wrap">
  <div class="arrow" [ngClass]="arrowPosition!"></div>
  <div class="feature-tooltip">
    <div class="header-wrap">
      <div class="icon-header-container">
        @if (isNew) {
          <rt-badge color="primary" [text]="'app.common.new' | translate" margin-right-small-x>
          </rt-badge>
        }
        <span class="header"> {{ title }} </span>
      </div>
      <rt-icon-button
        shape="square"
        size="small"
        iconName="close"
        variant="transparent-light"
        (click)="close.emit()"
      >
      </rt-icon-button>
    </div>
    <div class="body">
      <span class="info" [innerHTML]="description"></span>
      @if (learnMore) {
        <a
          [href]="learnMore"
          [innerHTML]="
            learnMoreCopy || ('app.common.see_how_it_works' | translate) | rtPreventOrphans
          "
          (click)="learnMoreClick.emit()"
          target="_blank"
          margin-left-small-xxx
        ></a>
      }
      <div class="actions" margin-top-small>
        <rt-button (click)="ctaClick.emit()" variant="tertiary">
          {{ ctaText || ('app.feature_tooltip.okay_got_it' | translate) }}
        </rt-button>
      </div>
    </div>
  </div>
</div>
